export default __webpack_public_path__ + "static/media/Soumyajit-Behera.8ad3d59b.pdf";